import ErrorImage from '../assets/error-icon.png';
import './error.css';

interface ErrorProps {
  returnUrl?: string;
}

const Error: React.FC<ErrorProps> = ({ returnUrl }) => {
  return (
    <div key="result" className="error-block">
      <img src={ErrorImage} alt="error-image" />
      <h1>
        Something went wrong
        <br />
        Algo salió mal
        <br />
        Algo deu errado
      </h1>

      {returnUrl && (
        <div className="main-action-button">
          <a href={`${returnUrl}`} target="_top">
            OK
          </a>
        </div>
      )}
    </div>
  );
};

export default Error;
